import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import SelectableCard from '../SelectableCard/SelectableCard';
import { actionCreators } from '../../data/Documents/actions';

const Terms = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { control } = useFormContext();

  const documents = useSelector(state => 
    state.Admin.scenes.Deliveries.scenes.new.data.documents.data.map(x => ({ 
      label: x.title, 
      value: x.id 
    }))
  );
  const isFetching = useSelector(state => 
    state.Admin.scenes.Deliveries.scenes.new.data.documents.isFetching
  );
  const hasError = useSelector(state => 
    state.Admin.scenes.Deliveries.scenes.new.data.documents.hasError
  );
  const error = useSelector(state => 
    state.Admin.scenes.Deliveries.scenes.new.data.documents.error
  );

  useEffect(() => {
    dispatch(actionCreators.getDocuments());
  }, [dispatch]);

  useEffect(() => {
    if (hasError && error?.status === 403) {
      const returnUrl = encodeURIComponent(window.location.pathname);
      navigate(`/mfa?returnUrl=${returnUrl}`, { replace: true });
    }
  }, [hasError, error, navigate]);

  // Keep the error display for non-403 errors
  if (hasError && error?.status !== 403) {
    return <div>Ett fel uppstod vid hämtning av köpvillkor.</div>;
  }

  if (isFetching) {
    return <div>Laddar köpvillkor...</div>;
  }

  return (
    <SelectableCard name="documents" control={control} options={documents} />
  );
};

export default Terms;